import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

const Name = ({ errors, name, onChange }) => (
  <div className={`form-element large ${errors.name ? 'has-errors' : ''}`}>
    <label className='block'>{I18n.t('pages.contact.name')}</label>
    <input type='text' value={name} onChange={event => onChange(event.target.value)} className='input-text' />
    {errors && errors.name ? <div className='simple-error'>{errors.name}</div> : null}
  </div>
)

export default Name

Name.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  errors: PropTypes.object
}
